import { observer } from 'mobx-react-lite'
import PropTypes from 'prop-types'
import { useStores } from '../../cls/stores/MobXProvider'
/**
 * Category component renders the name of a category based on its ID.
 * It retrieves the `categories` map from the MobX store and looks up
 * the `name` for the given `categoryId`. If no `categoryId` is provided
 * or the category is not found, it returns a hyphen (`'-'`).
 *
 * @component
 * @param {Object} props
 * @param {number} [props.categoryId] – The ID of the category to display.
 * @returns {string} The category name or `'-'` if not available.
 */
const Category = ({ categoryId, k = 'en' }) => {
	const { categories } = useStores()
	if (!categoryId) return '-'
	const cat = categories[categoryId]
	if (!cat || typeof cat !== 'object') return '-'
	return cat[k] ? cat[k] : '-'
}

Category.propTypes = {
	categoryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	k: PropTypes.string
}

export default observer(Category)
